import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { useLanguage } from "../i18n";
import { CONTACT } from "../data/cars";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const FaqSection = () => {
  const { t, lang } = useLanguage();

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative border-t border-white/10 py-24 sm:py-32"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 sm:px-8 lg:grid-cols-5">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-2"
        >
          <p className="font-mono-accent text-xs font-medium uppercase tracking-[0.35em] text-[#E63946]">
            {t.faq.eyebrow}
          </p>
          <h2 className="font-display mt-3 text-3xl font-bold tracking-tight text-white sm:text-4xl">
            {t.faq.title}
          </h2>
          <p className="mt-5 max-w-md text-sm leading-relaxed text-[#9E9E9E]">{t.faq.sub}</p>
          <a
            href={CONTACT.phoneHref}
            data-testid="faq-call-button"
            className="mt-7 inline-flex items-center gap-2 rounded-full border border-white/20 px-5 py-2.5 text-xs font-bold uppercase tracking-wider text-white transition-colors duration-300 hover:border-[#E63946] hover:text-[#E63946]"
          >
            <Phone className="h-3.5 w-3.5" />
            {CONTACT.phone}
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="lg:col-span-3"
        >
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {t.faq.items.map((item, i) => (
              <AccordionItem
                key={`${lang}-faq-${i}`}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-white/10"
              >
                <AccordionTrigger
                  data-testid={`faq-question-${i}`}
                  className="font-display text-left text-base font-bold text-white hover:text-[#E63946] hover:no-underline sm:text-lg"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-answer-${i}`}
                  className="text-sm leading-relaxed text-[#9E9E9E]"
                >
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FaqSection;
